import { temAcesso } from '@/shared/auth/temAcesso'

const Pleitos = () => import('./Pleitos.vue')
const Detalhes = () => import('./PleitosDetalhar.vue')
const PleitoForm = () => import('../componentes/PleitoForm.vue')

export default {
    path: 'pleitos/fornecedor',
    name: 'Pleitos_Fornecedor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    beforeEnter: (to, from, next) => {
        if (temAcesso('PLEITOS-FORN-00')) {
            next()
        }
    },
    children: [
        {
            path: '/pleitos/fornecedor',
            name: 'Pleitos_Fornecedor',
            component: Pleitos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-FORN-00')) {
                    next()
                }
            },
        },
        {
            path: '/pleitos/fornecedor/:pleitoId',
            name: 'Pleitos_Fornecedor_Detalhar',
            component: Detalhes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PLEITOS-FORN-00')) {
                    next()
                }
            }
        },
        {
            path: '/pleitos/inserir',
            name: 'Pleitos_Fornecedor_Inserir',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-FORN-01')) {
                    next();
                }
            }
        },
        {
            path: '/pleitos/fornecedor/:pleitoId/atualizar',
            name: 'Pleitos_Fornecedor_Atualizar',
            component: PleitoForm,
            beforeEnter(to, from, next) {
                if (temAcesso('PLEITOS-FORN-01')) {
                    next();
                }
            }
        }, 
    ]
}
